import Router from 'next/router'
import React, { useContext } from 'react'
import { FormattedMessage } from 'react-intl'
import { StyledBtn, StyledFindLesson } from './style'
import { getQueryParams } from '@utils/helpers'
import { FMIStudentProfileContext } from './context'

const FindALesson: React.FC<{ programId: string; hasSingleSearch: boolean }> = ({
  programId,
  hasSingleSearch = false,
}) => {
  const sessionid = getQueryParams('sessionId')
  const { isAdmin } = useContext(FMIStudentProfileContext)

  if (isAdmin) return null

  return (
    <StyledFindLesson>
      <div>
        <FormattedMessage
          id="Want to book by date and time instead?"
          defaultMessage="Want to book by date and time instead?"
        />
      </div>
      <div>
        <StyledBtn
          outline
          onClick={() =>
            sessionid
              ? Router.push(`/reschedule/?programid=${programId}&sessionid=${sessionid}`)
              : Router.push(
                  hasSingleSearch
                    ? `/scheduling/single-lesson?programid=${programId}&unitId=0000${
                        sessionid ? `&sessionid=${sessionid}` : ''
                      }`
                    : '/scheduling'
                )
          }
        >
          <FormattedMessage id="Find a lesson" defaultMessage="Find a lesson" />
        </StyledBtn>
      </div>
    </StyledFindLesson>
  )
}

export default FindALesson
